<template>
  <div>
      <span
        class="d-flex align-items-center align-content-center justify-content-center"
      >
        <img
          :src="require('@/assets/details.svg')"
          class="pointer mt-2"
          width="18px"
          @click.stop="show = !show"
        />
        <d-dropdown-form
          :show="show"
          :right="true"
          :identifier="`identifier-${booking.id}`"
          padding="5px"
          min-width="120px"
        >
      <template v-slot:dropdownbutton>
      </template>
      <template v-slot:dropdownbody>
        <div>
          <div class="p-2">
            {{ $t('general.actions.view') }}
          </div>
          <div class="border-bottom"/>
          <div class="p-2">
            {{ $t('general.actions.delete') }}
          </div>
        </div>
      </template>
    </d-dropdown-form>
      </span>
  </div>
</template>
<script>
export default {
  props: {
    booking: {
      type: Object,
      default: () => {
      }
    }
  },
  data: () => ({
    show: false,
  })
}
</script>
